import React, {useState} from 'react';
import Layout from './Layout';
import { XCircleIcon } from'@heroicons/react/solid';
import { CheckCircleIcon } from '@heroicons/react/solid';
import { requestPasswordReset } from './apiCore';

const RequestPasswordReset = () => {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');


  const showError = () => (
        <div className="rounded-md bg-red-50 p-4" style={{display: error ? '' : 'none'}}>
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <div className="mt-2 text-sm text-red-700">
              <p className='pl-5 space-y-1'>User with that email not found</p>
          </div>
        </div>
      </div>
    </div>    
   ); 

  const showSuccess = () => (
        <div className="rounded-md bg-green-50 p-4" style={{display: success ? '' : 'none'}}>
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <div className="mt-2 text-sm text-green-700">
              <p className='pl-5 space-y-1'>Password Reset sent to your email!</p>
          </div>
        </div>
      </div>
    </div>
    
   ); 

  const handleChange = (event) => {
      setEmail(event.target.value);
  };

  const clickSubmit = (event) => {
      event.preventDefault();
      setError(false);
      requestPasswordReset(email).then(data => {
          if (data.error) {
              setError(true);            
          }
          else {
              setSuccess(true);
          }
      })
  };

  return (
    <Layout>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset Password</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
              You will be sent a password reset link
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            {showError()}
            {showSuccess()}
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    onChange={handleChange}
                    value={email}
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>
                  <button onClick={clickSubmit}> Submit </button>
              </div>
            </div>
          </div>
        </div>
    </Layout>
  )

};

export default RequestPasswordReset;
